import { render, staticRenderFns } from "./WorkLoadTypePositions.vue?vue&type=template&id=60c2a37f"
import script from "./WorkLoadTypePositions.vue?vue&type=script&lang=js"
export * from "./WorkLoadTypePositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c2a37f')) {
      api.createRecord('60c2a37f', component.options)
    } else {
      api.reload('60c2a37f', component.options)
    }
    module.hot.accept("./WorkLoadTypePositions.vue?vue&type=template&id=60c2a37f", function () {
      api.rerender('60c2a37f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/WorkLoadTypePositions.vue"
export default component.exports